<div class="flex justify-center md:justify-start relative">
	<img src="assets/images/cross.avif" alt="" class="absolute top-1/2 -translate-y-1/2">
	<div class="h-36 flex flex-col items-center justify-center md:items-start text-peps-dark-200">
		@if(subtitle) {
			<h2 class="text-3xl sm:text-5xl z-30 text-left text-nowrap md:translate-x-8 uppercase">{{ subtitle }}</h2>
			<h1 class="text-4xl sm:text-8xl z-30 text-left text-nowrap md:translate-x-8 uppercase">{{ title }}</h1>
		} @else {
			<h1 class="text-4xl md:text-8xl z-30 text-left text-nowrap md:translate-x-8 uppercase">{{ title }}</h1>
		}
	</div>
</div>
